import { colors } from "@obs/tokens/index.stylex.ts";

export type Semantic = "default" | "secondary" | "disabled" | "success" | "warning" | "danger" | "accent";

export const semanticColorMap: Record<Semantic, string> = {
	default: String(colors.neutralTxtDefault),
	accent: String(colors.accentTxtDefault),
	secondary: String(colors.neutralTxtModerate),
	disabled: String(colors.disabledTxtDefault),
	success: String(colors.successTxtDefault),
	warning: String(colors.warningTxtDefault),
	danger: String(colors.dangerTxtDefault),
};
